const toggleScrolling = (
  value = false,
  element = document.getElementsByTagName("html")[0]
) => {
  if (value) {
    element.classList.add("overflow-hidden");
  } else {
    element.classList.remove("overflow-hidden");
  }
};

const scrollTo = (to = 0) => {
  window.scrollTo(null, to);
};

export { toggleScrolling, scrollTo };
